//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'base-error-modal',
  props: {
    error: {
      type: [Error, String],
      default () {
        return '';
      },
    },
    withoutClose: {
      type: Boolean,
      default () {
        return false;
      },
    },
  },
  computed: {
    errorMessage () {
      return this.error?.message || this.error;
    },
  },
  mounted () {
    this.$ym.emit('error', { errorMessage: this.error });
  },
  methods: {
    close () {
      this.$emit('close');
    },
    goHome () {
      this.$router.push('/');
    },
    goBack () {
      if (window.history.length > 1) this.$router.back();
      else this.goHome();
    },
  },
};
